import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import sermonReducer from './slices/sermonSlice';
import eventReducer from './slices/eventSlice';
import ministryReducer from './slices/ministrySlice';
import messageReducer from './slices/messageSlice';
import subscriberReducer from './slices/subscriberSlice';
import adminReducer from './slices/adminSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    sermons: sermonReducer,
    events: eventReducer,
    ministry: ministryReducer,
    messages: messageReducer,
    subscribers: subscriberReducer,
    admin: adminReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/login/fulfilled', 'auth/register/fulfilled'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production'
});

export default store;
